import produce from "immer";
import { RouteActions, RESET_FILTERS, UPDATE_SHOWS, UPDATE_FILTERS, ShowFilters } from "./action";
import { ShowSearchResult, EventInfo, ShowTime } from "../../typings/typings";

export interface ShowsState
{
    shows: ShowSearchResult[];
    filters: ShowFilters;
}

const initialState: ShowsState =
{
    shows: [],
    filters: {
        categories: [],
        shows: []
    },
};

export const reducer = (showsState = initialState, action: RouteActions): ShowsState => produce(showsState, draft =>
{
    switch (action.type)
    {
        case UPDATE_SHOWS: {
            draft.shows = action.shows;
            break;
        }
        case RESET_FILTERS: {
            draft.filters = { ...initialState.filters };
            break;
        }
        case UPDATE_FILTERS: {
            draft.filters = action.filters;
            break;
        }
    }
});

export const getShows = (state: ShowsState) => state.shows;

export const getShowFilters = (state: ShowsState) => state.filters;

export const getShowCategories = (state: ShowsState) => state.shows.reduce((categories: string[], show) =>
{
    if (show.categories)
    {
        show.categories.forEach((cat) =>
        {
            if (categories.indexOf(cat) < 0)
            {
                categories.push(cat);
            }
        });
    }

    return categories;
}, []);

export const getFilteredShows = (shows: ShowSearchResult[], filters: ShowFilters) =>
{
    let result = shows;

    // Reduce availble show times for each show, based on start and end dates.
    result = result.reduce((shows: ShowSearchResult[], show: ShowSearchResult) =>
    {
        if (filters.shows.length > 0)
        {
            if (!filters.shows.includes(show.name))
            {
                // Show is not included, return previous result
                return shows;
            }
        }

        if (filters.categories.length > 0)
        {
            // Filter out shows not in category
            const cats = show.categories?.filter(cat => filters.categories.includes(cat));
            if (cats?.length === 0)
            {
                return shows;
            }
        }

        const { startDate, endDate } = filters;
        if (startDate || endDate)
        {
            if (show.events)
            {
                const showEvents = show.events.reduce((events: EventInfo[], event: EventInfo) =>
                {
                    if (event.showTimes)
                    {
                        const showTimes = event.showTimes.reduce((showTimes: ShowTime[], showTime: ShowTime) =>
                        {
                            const showTimeMs = showTime.date.getTime();
                            if ((!startDate || showTimeMs >= startDate.getTime())
                                && (!endDate || showTimeMs <= endDate.getTime()))
                            {
                                showTimes.push({ ...showTime });
                            }
                            return showTimes;
                        }, []);

                        if (showTimes.length > 0)
                        {
                            events.push({ ...event, showTimes: showTimes });
                        }
                    }

                    return events;
                }, []);

                if (showEvents.length > 0)
                {
                    shows.push({ ...show, events: showEvents });
                }
            }
        }
        else
        {
            shows.push({ ...show });
        }


        return shows;
    }, []);

    return result;
};

export default reducer;